/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 24.01.13, 13:51
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

export class HTMLLinkFormatVO {
    public color: any;

    public textDecoration: string;

    constructor(color: any, textDecoration: string = "underline") {
        this.color = color;
        this.textDecoration = textDecoration;
    }
}
